import React from 'react';
import { Link } from 'react-router-dom';
import { PublicHomeNav } from '../../Common/PublicComponents/PublicHomeNav';
import { PublicSkipContentLink } from '../../Common/PublicComponents/PublicSkipContentLink';
import { PUBLIC_SITE_URL_ACTIVE_MAP } from '../../../App';

export function PublicContact() {

    return (
        <>
            <div className="wrapper">
                <PublicSkipContentLink />
                <PublicHomeNav publicSiteURLActiveMap={PUBLIC_SITE_URL_ACTIVE_MAP} />
                <div className="main" id="content">
                    <section className="section section-features section-offset">
                        <header className="section__head">
                            <div className="shell">
                                <div className="section__head-inner">
                                    <h1>Contact</h1>

                                    <nav className="breadcrumbs section__breadcrumbs">
                                        <ul>
                                            <li>
                                                <Link to='/'>Home</Link>
                                            </li>
                                            <li className="is-current" style={{ marginLeft: '0.5rem' }}>Contact</li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </header>
                        <div className="section__body">
                            <div className="shell">
                                <div className="section__body-inner pain-html" style={{ marginLeft: '2rem' }}>
                                    <h2>Department on Disability Services</h2>
                                    <hr></hr>
                                    <div className="view-agency-information-details">
                                        <strong>Office Hours</strong>
                                        <br />
                                        Monday to Friday, 8:30 am to 5:00 pm
                                        <br />
                                        <br /> <strong>Connect With Us</strong>
                                        <br />
                                        250 E Street, SW, Washington, DC 20024
                                        <br />
                                        Phone: (202) 730-1700
                                        <br />
                                        Fax: (202) 730-1843
                                        <br />
                                        Email:{" "}
                                        <a href="mailto:dds@dc.gov" title="dds@dc.gov" className="mailto">
                                            dds@dc.gov
                                        </a>
                                        <span className="mailto" />
                                        <br />
                                        <br />
                                        <a href="https://www.facebook.com/DDS.DC" target="_blank">
                                            <img
                                                src="assets/images/facebook.png"
                                                title="facebook"
                                                alt="facebook"
                                            />
                                        </a>
                                        <a href="https://twitter.com/DDS_DC" target="_blank">
                                            <img
                                                src="assets/images/twitter.png"
                                                title="twitter"
                                                alt="twitter"
                                            />
                                        </a>

                                        <h2>Related Links</h2>
                                        <hr></hr>
                                        <div className="views-field-field-askthedirectortitle">
                                            <a
                                                href="https://dcforms.dc.gov/webform/department-disability-services-ask-director"
                                                title="Ask the Director"
                                                target="_blank"
                                            >
                                                Ask the Director
                                            </a>
                                            <br />
                                        </div>
                                        <a
                                            href="https://oca.dc.gov/node/160652"
                                            title="Agency Performance"
                                            target="_blank"
                                        >
                                            Agency Performance
                                        </a>
                                        <br />
                                        <br />
                                        <div className="field field-name-field-language-support field-type-node-reference field-label-hidden">
                                            <div className="field-items">
                                                <div className="field-item even">
                                                    <a href="https://dds.dc.gov/New%20url%20alias">Amharic (አማርኛ)</a>
                                                </div>
                                                <div className="field-item odd">
                                                    <a href="https://dds.dc.gov/chinese%20222">Chinese (中文)</a>
                                                </div>
                                                <div className="field-item even">
                                                    <a href="https://dds.dc.gov/page/french-fran%C3%A7ais-dds6">French (Français)</a>
                                                </div>
                                                <div className="field-item odd">
                                                    <a href="https://dds.dc.gov/korean%2022">Korean (한국어)</a>
                                                </div>
                                                <div className="field-item even">
                                                    <a href="https://dds.dc.gov/spanish%202">Spanish (Español)</a>
                                                </div>
                                                <div className="field-item odd">
                                                    <a href="https://dds.dc.gov/vietnamese%2022">Vietnamese (Tiếng Việt)</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h2>Director</h2>
                                        <hr></hr>
                                    <div className="views-row views-row-1 views-row-odd views-row-first views-row-last">
                                        <div className="views-field views-field-field-image">
                                            {" "}
                                            <div className="field-content">
                                                <a href="https://dds.dc.gov/biography/andrew-reese">
                                                    <img
                                                        typeof="foaf:Image"
                                                        src="https://dds.dc.gov/sites/default/files/styles/thumbnail/public/dc/sites/dds/biography_content/images/ReeseAndrew418x268_0.jpg?itok=ALcTZcL1"
                                                        width={75}
                                                        height={56}
                                                        alt="Andrew Reese, Director, DDS"
                                                        title="Andrew Reese, Director, DDS"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="views-field views-field-title">
                                            {" "}
                                            <span className="field-content">
                                                <a href="https://dds.dc.gov/biography/andrew-reese">Andrew Reese</a>
                                            </span>
                                        </div>
                                        <div className="views-field views-field-field-position">
                                            {" "}
                                            <div className="field-content">Director</div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}